<template>
    <div id="mobile-menu">
        <div class="mobile-menuitem" @click="changeRoute('Index')">
            {{ $t('layout.menuIndex') }}
        </div>
        <div class="mobile-menuitem" @click="changeRoute('Technology')">
            {{ $t('layout.menuTech') }}
        </div>
        <div class="mobile-menuitem" @click="changeRoute('Contact')">
            {{ $t('layout.menuContact') }}
        </div>
        <div class="mobile-menuitem" @click="changeRoute('Login')">
            <a href="#" class="btn btn-light btn-rounded">
                {{ $t('layout.menuLogin') }}
            </a>
        </div>
        <div class="escape-mobilemenu" @click="$store.state.mobileMenu = false">
            <i class="fa fa-times"></i>
        </div>
        <div class="locale-wrapper">
            <div class="locale"
                 v-for="(locale, index) in locales"
                 :key="locale"
                 @click="$i18n.locale = index"
                 :class="{'active': $i18n.locale === index}"
            >
                <img v-if="index === 'da'" src="/static/images/flags/dk.png"/>
                <img v-if="index === 'en'" src="/static/images/flags/gb.png" />
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                locales: this.$i18n.messages
            }
        },
        methods: {
            changeRoute (path) {
                this.$router.push({name: path})
                this.$store.state.mobileMenu = false
            }
        }
    }
</script>
<style lang="scss">
    #mobile-menu{
        overflow: auto;
        padding: 30px;
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: linear-gradient(150deg, rgba(76, 69, 255, 0.85) 15%, rgba(58, 127, 255, 0.85) 70%), url("/static/images/bg.svg") top;
        background-size: cover;
        color: #F6F9FC;
        z-index: 9000;
        .mobile-menuitem, .escape-mobilemenu i.fa{
            font-size: 2rem;
            font-weight: 300;
        }
        .mobile-menuitem:not(:last-of-type){
            margin-bottom: 20px;
        }
        .escape-mobilemenu{
            position: absolute;
            top: 30px;
            right: 30px;
        }
        .custom-select{
            position: absolute;
            bottom: 30px;
        }
        .locale-wrapper{
            margin-top: 30px;
        }
        .locale{
            display: inline-block;
            transition: 0.3s ease all;
            img{
                width: 50px;
            }
        }
        .locale.active{
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// mobile-menu.vue?a0c60180